<template>
  <div :class="['help-wrapper', isFixed ? 'fixed' : '']">
    <div class="help">
      <p>
        {{ $t('orderDetail.assistance') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFixed: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
.help-wrapper {
  box-shadow: 0 -1.07vw 2.13vw 0 rgba(58, 86, 131, 0.07);
  background: #fff;

  &.fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    padding-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
    padding-bottom: env(safe-area-inset-bottom); /* iOS 11.2 */
  }

  .help {
    padding: 6.93vw 4.8vw;
  }

  p {
    font-size: 3.2vw;
    color: #84969C;
    text-align: center;

    // span {
    //   color: #1b6fdc;
    // }
  }
}
</style>
